import {combineReducers} from 'redux';

import userReducer from './User/index';
import stationsReducer from './Stations/index';
import zonesReducer from './Zones/index';
import areasReducer from './Areas/index';
import visitsReducer from './Visits/index';
import notesReducer from './Notes/index';
import navigationReducer from './Navigation/index';
import filtersReducer from "./Filters/index"
import mobileReducer from './Mobile';
import categoriesFilterReducer from './CategoriesFilter';

const rootReducer = combineReducers({
    mobile: mobileReducer,
    stations: stationsReducer,
    zones: zonesReducer,
    areas: areasReducer,
    visits: visitsReducer,
    user: userReducer,
    notes_actions: notesReducer,
    navigation: navigationReducer,
    filters: filtersReducer,
    categoriesFilter: categoriesFilterReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js